// Partials
import { AC } from "./Partials/AC";
import { IACProps } from "./Partials/AC/type";
import { CT } from "./Partials/CT";
import { ICTProps } from "./Partials/CT/types";

export const QuestionOS = {
    AC: (props: IACProps) => <AC {...props} />,
    CT: (props: ICTProps) => <CT {...props} />
}